import { type ChangeEvent } from "react";
import { validateImei } from "@/lib/formatters";
import { cn } from "@/lib/utils";

interface ImeiInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

export function ImeiInput({ value, onChange, label = "IMEI", required, id }: ImeiInputProps) {
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    // Solo permitir dígitos, máx 15
    const cleaned = e.target.value.replace(/\D/g, "").slice(0, 15);
    onChange(cleaned);
  }

  const showWarning = value.length === 15 && !validateImei(value);
  const showCheck = validateImei(value);

  return (
    <div className="space-y-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label} {required && <span className="text-error">*</span>}
      </label>
      <div className="relative">
        <input
          id={id}
          type="text"
          inputMode="numeric"
          value={value}
          onChange={handleChange}
          maxLength={15}
          className={cn(
            "input pr-10 font-mono",
            showWarning && "border-warning",
            showCheck && "border-success",
          )}
          placeholder="15 dígitos"
        />
        {showCheck && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-success text-lg">✓</span>
        )}
      </div>
      <p className="text-xs text-fg-muted">{value.length}/15 dígitos</p>
      {showWarning && (
        <p className="text-xs text-warning">
          IMEI no pasa validación Luhn. Verifica el dato (no es bloqueante).
        </p>
      )}
    </div>
  );
}
